<div class="grid-body">
  @if (isCheckingPayment()) {
    <div
      class="payment-check-overlay"
      aria-hidden="true"
      [style.background-color]="readerBackgroundColor()"
    ></div>
  }
  @if (!isUnauthorized()) {
    <nr-header></nr-header>

    <main class="reader">
      <nr-navigation-button direction="prev" (click)="prev()"></nr-navigation-button>

      <div class="container">
        @if (featureFlags.isEnabled('highlights')()) {
          <nr-text-selection-popover
            [position]="selectionRect()"
            (nrClose)="selectionRect.set(undefined)"
          ></nr-text-selection-popover>
        }

        <div
          #container
          class="reader__content"
          [class.reader__content--loaded]="isResourceLoaded()"
        ></div>

        @if (!isResourceLoaded() && !isUnauthorized()) {
          <nr-resource-skeleton></nr-resource-skeleton>
        }
      </div>
      <nr-navigation-button direction="next" (click)="next()"></nr-navigation-button>
    </main>

    @if (showTeacherQuestions()) {
      <odl-button
        [description]="'TEXT_SELECTION.ADD_ACTIVITY' | translate"
        id="create-question-button"
        class="reader__add-menu"
        [class.reader__add-menu--show-actions]="isHeaderFooterVisible()"
      >
        <odl-icon name="add_circle" slot="only-icon"></odl-icon>
      </odl-button>
      <odl-tooltip for="#create-question-button">
        {{ 'TEXT_SELECTION.ADD_ACTIVITY' | translate }}
      </odl-tooltip>
      <nr-create-question-actions
        [menuFor]="'#create-question-button'"
      ></nr-create-question-actions>
    }
    <nr-footer></nr-footer>
  }
</div>

@if (isTTSDialogOpen()) {
  <nr-tts></nr-tts>
}

@if (quizDraft()) {
  @if (quizMode() === 'note') {
    <nr-annotation-dialog></nr-annotation-dialog>
  } @else if (quizMode() === 'voice') {
    <nr-voice-recording-dialog></nr-voice-recording-dialog>
  } @else {
    <nr-quiz-editor-dialog></nr-quiz-editor-dialog>
  }
}
@if (quizToAnswer()) {
  @if (quizToAnswer()?.materialKind === 'voice') {
    <nr-voice-recording-dialog></nr-voice-recording-dialog>
  } @else {
    <nr-quiz-taking-dialog></nr-quiz-taking-dialog>
  }
}

<nr-text-info></nr-text-info>
@if (featureFlags.isEnabled('finder')()) {
  <nr-search></nr-search>
}
<nr-note-dialog-manager></nr-note-dialog-manager>
@if (featureFlags.hasAnyMoreOption()) {
  <nr-more-options></nr-more-options>
}
<nr-unauthorized-dialog></nr-unauthorized-dialog>
<nr-offline-alert></nr-offline-alert>
@if (isOfflineDialogOpen()) {
  <nr-offline-reading-dialog></nr-offline-reading-dialog>
}
<nr-payment-blocked-dialog></nr-payment-blocked-dialog>
<nr-unanswered-questions-dialog></nr-unanswered-questions-dialog>
